import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import classnames from 'classnames';
import { createUseStyles, Icon } from '@Sage/hoi-poi-ui';

import styles from './styles';
const useStyles = createUseStyles(styles, 'FullModalBlank');

const FullModalBlank = ({
    withCloseIcon,
    onRequestClose,
    contentLeft,
    contentLeftClassName,
    contentCenter,
    contentCenterClassName,
    contentRight,
    contentRightClassName,
    children,
    className,
    overlayClassName,
    headerClassName,
    closeClassName,
    isOpen,
    onAfterOpen,

    ariaHideApp = false,
    closeTimeoutMS = 500,
    shouldCloseOnEsc = true,
    shouldCloseOnOverlayClick = true,
}) => {
    const classes = useStyles();
    // Classes
    const rootClassNames = classnames(classes.root, className);
    const contentLeftClassNames = classnames(classes.contentLeft, contentLeftClassName);
    const contentCenterClassNames = classnames(classes.contentCenter, contentCenterClassName);
    const contentRightClassNames = classnames(classes.contentRight, contentRightClassName);
    const overlayClassNames = classnames(classes.overlay, overlayClassName);
    const headerClassNames = classnames(classes.header, headerClassName);
    const closeClassNames = classnames(classes.close, closeClassName);

    const renderClose = useMemo(() => {
        if (!withCloseIcon || !onRequestClose) return null;

        return (
            <div className={closeClassNames} onClick={onRequestClose}>
                <Icon name="close" />
            </div>
        );
    }, [closeClassNames, onRequestClose, withCloseIcon]);

    const renderLeft = useMemo(() => {
        if (!contentLeft) return null;
        return <div className={contentLeftClassNames}>{contentLeft()}</div>;
    }, [contentLeft, contentLeftClassNames]);

    const renderCenter = useMemo(() => {
        if (!contentCenter) return null;
        return <div className={contentCenterClassNames}>{contentCenter()}</div>;
    }, [contentCenter, contentCenterClassNames]);

    const renderRight = useMemo(() => {
        return (
            <div className={contentRightClassNames}>
                {contentRight()}
                {renderClose}
            </div>
        );
    }, [contentRight, contentRightClassNames, renderClose]);

    return (
        <Modal
            ariaHideApp={ariaHideApp}
            className={rootClassNames}
            overlayClassName={overlayClassNames}
            closeTimeoutMS={closeTimeoutMS}
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            shouldCloseOnEsc={shouldCloseOnEsc}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        >
            <div className={headerClassNames}>
                {renderLeft}
                {renderCenter}
                {renderRight}
            </div>
            {children}
        </Modal>
    );
};

FullModalBlank.propTypes = {
    children: PropTypes.any,
    ariaHideApp: PropTypes.bool,
    className: PropTypes.string,
    overlayClassName: PropTypes.string,
    headerClass: PropTypes.string,
    closeTimeoutMS: PropTypes.number,
    isOpen: PropTypes.bool,
    onAfterOpen: PropTypes.func,
    onRequestClose: PropTypes.func,
    shouldCloseOnEsc: PropTypes.bool,
    shouldCloseOnOverlayClick: PropTypes.bool,
    withCloseIcon: PropTypes.bool,
    contentLeft: PropTypes.func,
    contentLeftClassName: PropTypes.string,
    contentCenter: PropTypes.func,
    contentCenterClassName: PropTypes.string,
    contentRight: PropTypes.func,
    contentRightClassName: PropTypes.string,
    closeClassName: PropTypes.string,
};

export default memo(FullModalBlank);
